module.exports = __webpack_public_path__ + "fonts/Lexend-300-vietnamese7.59e5d08.woff2";